// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { theme } from '../../commons/theme';

type Props = {
  header: Node,
  messages: Node[],
};

export function MessagesContent({ header, messages }: Props): Node {
  return (
    <>
      <MessagesHeader>{header}</MessagesHeader>
      <MessagesList>
        {messages.map((message, index) => (
          <li key={index}>{message}</li>
        ))}
      </MessagesList>
    </>
  );
}

const MessagesHeader = styled.h1`
  text-align: center;
  font-family: ${theme.fontFamily.display};
  font-size: 22px;
  font-weight: normal;
`;

const MessagesList = styled.ul`
  text-align: center;
  font-family: ${theme.fontFamily.sansSerif};
  color: ${theme.colors.gray(20, 0.8)};
  list-style: none;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 16px;
`;
